module.exports = __webpack_public_path__ + "img/wechat.8957b87b.jpg";